var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCollapse = function SvgCollapse(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: "new 0 0 20 20"
    },
    xmlSpace: "preserve"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.1 8h2.4c.8 0 1.5.7 1.5 1.5s-.7 1.5-1.5 1.5H10v6.5c0 .8-.7 1.5-1.5 1.5S7 18.3 7 17.5v-2.4l-3.4 3.4c-.6.6-1.5.6-2.1 0-.6-.6-.6-1.5 0-2.1L4.9 13H2.5c-.8 0-1.5-.7-1.5-1.5S1.7 10 2.5 10H9V3.5c0-.8.7-1.5 1.5-1.5s1.5.7 1.5 1.5v2.4l3.4-3.4c.6-.6 1.5-.6 2.1 0 .6.6.6 1.5 0 2.1L14.1 8z"
  })));
};
export default SvgCollapse;